import { useState } from "react";
import { ButtonUnstyled, DividerAtom } from "../../atoms";
import { LabelMolecule } from "../label";
import styles from "./styles.module.scss";

interface Props {
  label: string;
  children: any;
  defaultFolded?: boolean;
}

export function FoldableMolecule(props: Readonly<Props>) {
  const [folded, setFolded] = useState(props.defaultFolded);

  let className = styles.container;
  if (!folded) className += ` ${styles["container--unfolded"]}`;

  return (
    <>
      <div className={className}>
        <ButtonUnstyled onClick={() => setFolded(!folded)} id={"collab"}>
          <LabelMolecule label={props.label} />
        </ButtonUnstyled>
      </div>

      <DividerAtom verticaal />
      {!folded && props.children}
    </>
  );
}
